import { Box } from '@mui/material'
import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { EditProductionView } from './EditProduction.view'
import { FetchProductionParams } from './EditProduction.types'
import { useParams } from 'react-router-dom'
import { useBreadcrumbsData } from 'Common/Breadcrumbs/Breadcrumbs.data'
export const EditProductionPage = () => {
  const { workcentreId, planId, sourcesiteId } =
    useParams<FetchProductionParams>()

  useBreadcrumbsData({
    plan_id: planId,
    workcentre_id: workcentreId,
  })

  return (
    <Page>
      <Box display="flex" flexDirection="column" flex={1}>
        <PageHeader title="Edit production" />
        <Box>
          <EditProductionView
            planId={planId}
            sourcesiteId={sourcesiteId}
            workcentreId={workcentreId}
          />
        </Box>
      </Box>
    </Page>
  )
}
